'use strict';

module.exports = {
  color: function () {
    var color = Math.floor(Math.random() * (16 * 16 * 16 * 16 * 16 * 16 - 1)).toString(16);
    color = '#' + ('000000' + color).slice(-6);
    return this.upper(color);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/generate-random-data/lib/random/color.js
// module id = 762
// module chunks = 0